/*!
 * Party Hearts: falling, fading hearts in the colors of a country's flag, with small
 * flags of that country, played once when a visitor opens the site.
 *
 * Countries: Saudi Arabia, Kuwait, Oman, UAE, Bahrain, Qatar, Jordan, Iraq.
 * Each one celebrates from 5 days before its national day until 2 days after it.
 *
 * Edit the CONFIG block below, or define window.PartyHeartsConfig before this
 * script loads to override any value without touching this file.
 */
(function () {
  'use strict';

  var CONFIG = {
    enabled: true,            // master switch: false turns the effect off everywhere

    // 'everyone' : visitors from an event country see their own country's celebration;
    //              everyone else sees the celebration(s) running today.
    // 'local'    : only visitors located in an event country see anything.
    audience: 'everyone',

    // Countries taking part. Remove a code to switch that country off.
    countries: ['SA', 'KW', 'OM', 'AE', 'BH', 'QA', 'JO', 'IQ'],

    // The celebration runs from daysBefore days before the day, through the day itself,
    // until daysAfter days after it (5 + 1 + 2 = 8 days in total).
    daysBefore: 5,
    daysAfter: 2,

    // The day each country celebrates, as [month, day] (1 = January ... 12 = December).
    // Add a second day with e.g. SA: [[2, 22], [9, 23]] (Founding Day + National Day).
    dates: {
      SA: [[9, 23]],    // National Day, 23 September
      KW: [[2, 25]],    // National Day, 25 February
      OM: [[11, 18]],   // National Day, 18 November
      AE: [[12, 2]],    // National Day, 2 December
      BH: [[12, 16]],   // National Day, 16 December
      QA: [[12, 18]],   // National Day, 18 December
      JO: [[5, 25]],    // Independence Day, 25 May
      IQ: [[10, 3]]     // National Day, 3 October
    },

    showOncePerSession: true, // false = plays on every page load
    durationMs: 9000,         // how long new hearts keep spawning
    density: 1,               // 0.5 = fewer hearts, 2 = twice as many
    flagRatio: 0.15,          // share of particles that are flags (0 = none, 0.3 = lots)
    respectReducedMotion: true,
    forceParam: 'party',      // ?party=1 forces it on, ?party=0 skips it, ?party=QA forces Qatar
    dateParam: 'party_date',  // ?party_date=2026-12-15 pretends it is that day (for testing)
    zIndex: 2147483000
  };

  var user = window.PartyHeartsConfig;
  if (user && typeof user === 'object') {
    for (var k in user) { if (Object.prototype.hasOwnProperty.call(user, k)) CONFIG[k] = user[k]; }
  }

  // Official flag artwork (public domain, Wikimedia Commons), minified and inlined so
  // there is nothing to host. Flags are only ever drawn upright and never mirrored.
  var FLAG_SVG = {};
  FLAG_SVG.SA =
    '<svg xmlns="http://www.w3.org/2000/svg" width="900" height="600" enable-background="new 0 0 1773 1182" version' +
    '="1.1" viewBox="0 0 900 600"><path d="m0 600h900v-600h-900z" fill="#005430" stroke-width=".4"/><g transform="s' +
    'cale(.4)"><g><g transform="matrix(7.3,0,0,-6.8,1800,635.5)"><path d="m0 0c-0 4.2-1.5 15.4-1.9 19.1-.4 3.8-.8 7' +
    '.2-.7 8 .1 .8 1.2-1.1 1.8-1.2 0.3 .1 .2 1.2-.4 2.2-.4 .7-1.6 3.2-2.4 4.7-.4 0.7-.4 1.1-.6 1.2-.2 .1-1.6-2.9-1.' +
    '4-3.3 .4-.6 .6-.9 .7-2 .1-1.1 .6-8.9 1.2-14.7 .5-4.4 1.6-14 1.6-20 0-1.9-.2-3.8-.4-4.6-.6-1.2-1.6-2.3-5.1-4.6-' +
    '4-2.5-9.4-4.7-11.7-6.1-1.4-.9-1-1 .3-.6 1.2 .4 7.7 1.6 10.8 3 2.9 1.3 4.8 3.6 6.3 6.9 1.8 4 1.9 7.5 1.9 11.9" ' +
    'fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1709.3,422)"><path d="m0 0c0.31 .1 2.9 .3 3.6 .1-.5-.7-3.5-' +
    '2.3-3.5-2.5 .1-.2 2.1 .4 2.8 .7 .4 .3 .7 .7 1 1.1 .7 .9 1.6 2.6 1.4 2.8-.4 .3-3.9 .1-4.3 .1-.3-0-1.1-1.6-1.2-2' +
    '-.1-.4 0-.3 .4-.2" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1747.6,588.6)"><path d="m0 0c0.535 2 .7 ' +
    '4.3-.1 6.8-.7 2.6-2.6 4.1-3.9 5l-.2-2.5s1.879-1 3.2-3.6c0.814-1.6 1.2-3.9 .5-6.4-.1-.6 .3-.3 .6 .7" fill="#fff' +
    '"/></g><g transform="matrix(7.3,0,0,-6.8,1602.4,672.6)"><path d="m0 0c0.482 1.8 0.6 3.9-.1 6.2-.7 2.3-2.3 3.7-' +
    '3.6 4.5l-.2-2.2s1.692-.9 2.8-3.2c0.734-1.5 1-3.5 .5-5.8-.1-.6 .3-.3 .5 .6" fill="#fff"/></g><g transform="matr' +
    'ix(7.3,0,0,-6.8,1098.3,444.5)"><path d="m0 0c0.774-1.5 1.1-3.7 .5-6.1-.1-.6 .3-.3 .5 .6 .5 1.9 .6 4.1-.1 6.5-.' +
    '7 2.4-2.5 3.9-3.7 4.7l-.2-2.4s1.785-1 3-3.4" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,758,449.9)"><p' +
    'ath d="m0 0c0.65-1.6 .7-3.9-.4-6.2-.2-.6 .3-.3 .7 .6 .9 1.8 1.3 4.1 .9 6.5-.4 2.6-2.2 4.3-3.6 5.2l-.6-2.3s1.87' +
    '9-1.2 2.9-3.8" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,852.1,698.6)"><path d="m0 0c0.826 1.7 1.2 2.' +
    '8 1.5 4.7 .3 1.7 .3 3.7 .2 5.8 2.5 1.1 5.4 2.9 6.4 3-.7-2.5 .9-5.2 4.2-4.9 .2-2.8 .5-5.3 .6-6.8 .3-3 .2-6.9 .2' +
    '-7.5-0-.7 .4-.5 .9 .9 .6 2 .8 7.2 .6 10.6-.1 .9-.1 2-.3 3.3 2.1 1.1 2.5 3.1 3.3 4 .7-2.7 4.6-3.1 5.9-2.5 1.5 .' +
    '7 2 2 2.4 5 .4 3-.7 4.2-1.1 4.5-0-.4-1-3.9-1-3.9s0.933-1.1 1-1.6c-.8-.7-2.4-.8-3.7-.3-1.3 .5-1.8 1.3-1.7 1.9 .' +
    '1 .6 .6 1.1 .6 1.8 0 .7-.3 .5-.8-.1-.5-.6-.9-1.2-1.6-2.6-.6-1.1-1.6-2.5-3.3-2.9-.3 3.3-.6 6.7-.8 8.9-.1 1.2-1.' +
    '3 11.1-1.3 12.2-.1 1-.2 2.1-.2 2.7 0 .4 .3 .3 .7-.2 .4-.4 1.1-1.2 1.2-1.2 .4 .2-9e-3 1.5-.5 2.7-.5 1.2-2.3 5.8' +
    '-2.6 5.9-.2 .1-1.4-2.7-1.4-3.3 .2-.3 .7-.9 .7-2.5 6e-3 -.4 .3-4.5 .6-8.4 .3-3.4 .7-6.7 .8-7 .3-2.6 .6-6.3 1-9.' +
    '9-1.9 .4-2.4 1.7-2.4 2.5 0 .9 .4 1.9 .2 2.1-.4 .2-2.5-1.1-5.6-2.5-.9-.4-1.8-.8-2.8-1.2-.3 2.5-.6 4.8-.8 6.6l-0' +
    ' .2c1.992 .1 3.6 1.2 4.4 2.3 .9 1.3 1.6 4 1.6 6 .1 2-1.5 5.8-1.8 7-.4 1.2-.6 2-.6 2.4-0 .4 .8-.5 1.4-.7 .4-.1 ' +
    '.2 .8-.2 1.4-.4 .6-2.8 4.5-3 4.2-.1-.2-1.1-3.1-1.1-3.5 .4-.3 .8-1 .9-1.7 0-.7 .6-3.8 1.1-5.6 .6-1.7 1.8-5.1 1.' +
    '9-6-.9-.7-2.9-1.8-4.9-1.8-.3 3-.8 6.6-1 9.1-.1 1-.1 2-.1 2.5 0 .4 .3 .4 .7-.1 .4-.4 1-1.1 1.1-1 .3 .1 0 1.1-.5' +
    ' 2.2s-2.7 6-3 6.2c-.2 .1-1.1-2.6-1.2-3.2 .2-.3 .7-.9 .7-2.4 0-1.2 .6-7.3 1.1-12.7-2 1.1-2.7 2.7-2.9 5.4-.2 1.9' +
    '-.2 5.3-.8 8.2-.3 1.6-1.1 3.3-1.9 4.1-.2-.5-1.1-3.8-1.1-3.8 0.3-.9 1.2-4.1 1.2-6.9-0-2.8-.2-5.5-3.1-7.3-2.9-1.' +
    '9-7.2-1.1-8.2 1.8-1.1 2.9 1.3 10.2 1.3 12-0 1.7-.3 2-1 1.7-.7-.3-2-1.9-3.2-4.7-1.2-2.7-1.7-6.1-2.4-8.3-.7-2.3-' +
    '1.7-4.6-3.4-4.5-1.6 .1-2.5 1.8-3 4.1-.5 2.4-.2 5.5-.1 6.3 .3 2-.5 1.6-.9-1.5-.3-1.9-.6-5 .5-8.3 1.1-3.2 2.9-4.' +
    '4 4.5-4 1.6 .4 3 4.4 3.5 6.2 .5 1.8 2.7 9.8 3.9 10.2 .2-.9-1-3.8-1.3-7.2-.4-3.4 .5-8 4.5-8.8 4-.8 6.7 2 7.7 4 ' +
    '1 1.9 1.4 4 1.6 5 .1-2.6 1.8-6.7 5-7.9l0.33-.1c0.197-2.1 .5-4.9 .8-7.9-.6-.2-1.3-.4-1.9-.6-.1 .3-.2 .6-.3 .8-1' +
    ' 2.3-2.6 4.4-4.8 4.2-2.3-.1-4.8-3.5-4.7-5.9 .1-1.6 .9-3 3.9-3.3 1.4-.2 2.8 8e-3 4.3 .4 .2-.7 .3-1.3 .4-1.9-1-1' +
    '.2-8.8-7.6-14.7-8.2-5.9-.6-7.7 2.7-7.8 6.1-0 2.6 1.4 5.1 2.4 6.9 1.4 1.1 2.6 2.5 3.3 3.6 .2-.1 .4-.3 .6-.4 .7-' +
    '.4 1-1.1 1-1.1 .1 .2 .7 1.4 .5 2-.1 .1-.6 .5-1.3 .9 .7 1.8 .7 3.6-.2 4-1 .4-2.2-.8-2.8-1.6-.3-.4-.4-.8-.4-1.2-' +
    '4e-3 -.5 .2-.9 .7-1.3 .5-.4 1-.7 1.5-1-1.3-1.5-4.3-3.6-6.2-4.9-.1 .2-.3-0-.7-.5l-.5-.3c-1.5-1-5.1-3.1-5.8-3.7-' +
    '.7-.5-.3-.4 0-.3 .5 .3 1.1 .6 1.9 1 1 .5 2.2 1.2 3.4 1.8-.3-.6-.7-1.4-1-2.2-1.4-3.6-3.7-11 1.2-15.5 4.7-4.3 12' +
    '.8-2.6 19.5 1.8 6.7 4.4 8.1 6 9.2 7.6m-21.8 17.7c-.2 .2-.3 .4-.1 .6 .2 .2 .5 .4 .9 .5 .7 .1 1-.8 .7-2.2-.6 .4-' +
    '1.1 .8-1.6 1.1m15.348-6.1c-3.4-0-3.6 .7-3.5 1.1 .1 .4 1.1 1.6 2.5 .8 .6-.3 1.2-1 1.8-1.9-.3-0-.5-0-.8-0m-10.4-' +
    '19.4c-6.4-1.9-12.7 1-13.1 6.9-.3 4.5 1.2 7.8 2.2 9.7 .9 .5 1.8 1 2.5 1.4-1.7-2.9-2.7-6.9-2-10.2 .7-3.8 3.8-6.1' +
    ' 8.9-5.3 5.1 .7 12 6 13.9 7.9 .6 .7 1 1.4 1.5 2.7 .2 .5 .5 1.2 .6 2 .1 .5 .1 1.1 .1 1.6 .6 .2 1.2 .4 1.8 .6 .2' +
    '-2.4 .4-4.7 .4-6.8-3.2-4-10.4-8.7-16.9-10.6" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1551,647.9)"><' +
    'path d="m0 0c-.2 3.9-.7 11-1 14.5-.3 3.2-.8 7.6-1.1 11.4-.1 1-.1 1.9-.1 2.4 0 .4 .4 .3 .8-.2s1.01-1 1.1-.9c0.3' +
    '85 .2-.1 1.3-.6 2.4-.5 1.2-2.7 5.9-3.1 6.1-.2 .1-1.2-2.8-1.3-3.3 .2-.3 .7-.9 .7-2.4 .1-1.6 .8-8.7 1.3-14.5 .4-' +
    '4 .8-10.6 1.2-15.5-0-8e-3 .3-4.7 .4-5.2 .2-3 .1-6.9 .1-7.5-0-.7 .4-.6 .9 .9 .5 1.5 .8 4.9 .8 7.9z" fill="#fff"' +
    '/></g><g transform="matrix(7.3,0,0,-6.8,1417.5,555.7)"><path d="m0 0c-.7-.2-1.7 .5-1.6 2.1 .1 1.4 .6 2.8 .9 3.' +
    '6 0.3 1.2 .3 2.3 0 1.7-.6-1.4-1.6-4.2-1.9-6-.2-1.9 .3-3.1 1.1-3.5 .9-.5 1.6 .3 2.1 1.5 .4 1.2 .4 2.5 .1 2.2-.3' +
    '-.3-.4-1.4-.7-1.5" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1348.2,594.5)"><path d="m0 0c0.35 1 .4 2' +
    ' .2 1.5-.6-1.2-1.7-3.6-2.1-5.2-.3-1.6 .1-2.7 .7-3.1 .8-.5 1.5 .1 2 1.2 .5 1 .5 2.2 .2 1.9-.3-.3-.4-1.2-.7-1.3-' +
    '.6-.1-1.5 .6-1.3 2 .2 1.2 .8 2.4 1 3.1" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1146.4,737.9)"><pat' +
    'h d="m0 0c0.585 1 .9 2.1 .5 1.6-.9-1.2-2.6-3.5-3.3-5.2-.7-1.7-.5-3 .1-3.6 .8-.7 1.6-.1 2.4 .9 .7 1 1 2.3 .6 2.' +
    '1-.3-.2-.7-1.3-1-1.3-.7-0-1.5 .9-1 2.4 .4 1.3 1.3 2.5 1.7 3.2" fill="#fff"/></g><g transform="matrix(7.3,0,0,-' +
    '6.8,1500.2,535.5)"><path d="m0 0c-.7-.2-1.7 .6-1.5 2.2 .2 1.4 .8 2.7 1.1 3.6 .4 1.1 .4 2.3 .1 1.6-.6-1.4-1.9-4' +
    '.1-2.2-5.9-.3-1.9 .2-3.1 .9-3.5 .9-.6 1.6 .2 2.2 1.4 .5 1.1 .5 2.5 .2 2.2-.3-.3-.4-1.4-.8-1.5" fill="#fff"/></' +
    'g><g transform="matrix(7.3,0,0,-6.8,1498.7,666.1)"><path d="m0 0c0.918-.6 1.6 .2 2.2 1.4 .5 1.1 .5 2.5 .2 2.2-' +
    '.3-.3-.4-1.4-.8-1.5-.7-.2-1.7 .6-1.5 2.2 .2 1.4 .8 2.7 1.1 3.6 .4 1.1 .4 2.3 .1 1.6-.7-1.4-1.9-4.1-2.2-5.9-.3-' +
    '1.9 .2-3.1 .9-3.5" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1584.4,499.2)"><path d="m0 0c0.442 1.4 .' +
    '5 2.7 .2 2-.8-1.7-2.3-4.9-2.6-7.2-.4-2.2 .2-3.7 1.1-4.3 1.1-.7 2 .3 2.6 1.7 .6 1.4 .6 3 .2 2.6-.3-.4-.5-1.7-.9' +
    '-1.8-.8-.2-2 .8-1.8 2.7 .2 1.7 1 3.3 1.3 4.3" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,899.5,661.6)"' +
    '><path d="m0 0c0.723 1.7 1 3.4 .5 2.5-1.2-2-3.4-5.9-4.2-8.7-.8-2.8-.2-4.7 .9-5.5 1.3-1 2.5 .1 3.5 1.8 .9 1.6 1' +
    '.1 3.7 .6 3.3-.5-.4-.9-2.1-1.4-2.2-1-.2-2.4 1.2-2 3.6 .4 2.1 1.6 4 2.1 5.3" fill="#fff"/></g><g transform="mat' +
    'rix(7.3,0,0,-6.8,1639,775)"><path d="m0 0c0.554 .5 5.4 3.3 6.3 3.9 0 0 .9 1.6 .6 1.8-.3 .2-2-1.6-3.1-1.6-1.1-0' +
    '-2.6 .8-2.6 1.5 .1 .5 1.5 1.3 1.9 1.4 .5 0 .4-1.1 .6-1.3 .2-.1 .8 .8 .9 1.2 .1 .4 0 2-.9 1.8-1.4-.4-3.5-3.1-3.' +
    '7-4-.2-.9 1-1.6 2-2-.1-0-.8-.4-1.2-.9 0 0-.5-.6-.7-1.7" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,151' +
    '9,798.5)"><path d="m0 0c0.554 .5 5.4 3.3 6.3 3.9 0 0 .9 1.6 .6 1.8-.3 .2-2-1.6-3.1-1.6-1.1-0-2.6 .8-2.6 1.5 .1' +
    ' .5 1.5 1.3 1.9 1.4 .5 0 .4-1.1 .6-1.3 .2-.1 .8 .8 .9 1.2 .1 .4 0 2-.9 1.8-1.4-.4-3.5-3.1-3.7-4-.2-.9 1-1.6 2-' +
    '2-.1-0-.8-.4-1.2-.9 0 0-.5-.6-.7-1.7" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1248.7,458.7)"><path ' +
    'd="m0 0c0.432-.5 3.3-4.4 5.5-6.9 2.2-2.4 6-6.4 8.8-9.1 .5-.5 1.1-1.1 1.7-1.7 .7-5.8 1.5-13.3 1.9-16.4 .3-3 .4-' +
    '6.9 .4-7.5 6e-3 -.7 .5-.5 .9 1 .6 2 .6 7.2 .3 10.6-.2 2.1-.6 6.1-1.1 9.8 1.6-1.8 3.2-3.5 4.3-4.8 1.9-2.4 3.6-4' +
    '.2 4.5-6.8 0.7-1.8 .6-3.3 .9-3.6 .2-.2 .5 1.9 .2 4.1-.5 3.4-1.2 4.9-5.3 9.8-1.6 1.9-3.4 3.8-5.2 5.7-.1 .6-.1 1' +
    '.1-.2 1.6-.1 1.1-1.5 11.1-1.6 12.2-.1 1-.3 2.1-.2 2.6 0 .4 .3 .3 .7-.2 .4-.4 1.1-1.2 1.2-1.1 .4 .2-0 1.5-.6 2.' +
    '6-.5 1.1-2.4 5.7-2.8 5.9-.2 .1-1.3-2.8-1.4-3.3 .2-.3 .7-.9 .7-2.4 0-.4 .4-4.5 .8-8.4 .4-3.4 .9-6.6 .9-7l2e-3 0' +
    'c-1.8 1.8-3.5 3.4-4.5 4.3-2.3 2.3-7.4 7.7-7.6 8.5-0 .3 .3 .1 1.1-0 .7-.1 1.4-.4 1.3-8e-3 -.1 .2-.3 .6-1 1.1-.7' +
    ' .5-2.5 1.7-3.8 2.5-1.3 .9-2 1.6-2.3 1.4-.1-.1-0-3 .1-3.4 .3-0 .9-.5 1.3-1" fill="#fff"/></g><g transform="mat' +
    'rix(7.3,0,0,-6.8,1275.3,423.1)"><path d="m0 0c0.547 .1 3.1 .1 4.1-.2-.4-.3-3-1.7-3.6-2.1-.5-.3-.7-.5-.4-.5 .8 ' +
    '.2 2.5 .5 3.3 1 .8 .4 2.1 2.3 2.6 3 .5 .7 .5 1.1 .4 1.3-.5 .3-3.9 .6-5.5 .2-.5-.3-1.3-2.1-1.5-2.5-.1-.4 0-.3 .' +
    '6-.2" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1380.6,421.6)"><path d="m0 0c0.442 .1 2.5 0 3.3-.1-.3' +
    '-.2-2.5-1.4-2.9-1.7-.4-.3-.5-.4-.3-.4 .6 .2 2 .4 2.7 .8 .6 .3 1.7 1.9 2.1 2.4 .4 .6 .4 .9 .3 1-.4 .3-3.1 .5-4.' +
    '5 .1-.4-.3-1.1-1.7-1.2-2-.1-.3 0-.3 .5-.2" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1466.2,420.5)"><' +
    'path d="m0 0c0.44 .1 2.5 0 3.3-.1-.3-.2-2.5-1.4-2.9-1.7-.4-.3-.5-.4-.3-.4 .6 .2 2.1 .4 2.8 .8 .6 .3 1.4 1.9 1.' +
    '8 2.4 .4 .6 .4 .9 .3 1-.4 .3-2.9 .5-4.2 .1-.4-.3-1.1-1.7-1.2-2s0.038-.3 .5-.2" fill="#fff"/></g><g transform="' +
    'matrix(7.3,0,0,-6.8,1412.8,462.2)"><path d="m0 0c-.7-1.2 .2-2.1 .5-3.1-.4-.4-1.1-0-1.3 .3-.5 .8-.3 2.3-.9 2.6-' +
    '.1-.4-.2-.9-.2-.9s0.419-1.1 .3-1.8c-.1-.4-.4-.9-.9-.9-1.2-0-.6 1.9-1.1 3-.1-.3-.2-.6-.3-.8 .1-.3 .1-.7 .1-.9 0' +
    '-.5-6e-3 -1 .1-1.4 .1-.6 .4-.9 .8-1 .9-.1 1.3 .7 1.5 1.4 .2-.7 1.4-1.4 2-.6 .8 1.1 .2 2-.2 3-.3 .8-.2 1.2-.4 1' +
    '" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1163.1,441)"><path d="m0 0c0.063-.5 .3-.8 .7-.9 .8-.1 1.2' +
    ' .6 1.3 1.1 .1-.6 1.1-1.3 1.7-.6 .7 .9 .2 1.7-.1 2.6-.2 .7-.1 1.1-.3 .9-.7-1 .1-1.8 .3-2.7-.4-.3-.9 0-1.1 .3-.' +
    '4 .7-.2 2-.6 2.2-.1-.4-.2-.8-.2-.8s0.313-.9 .2-1.5c-.1-.4-.4-.8-.8-.8-1 0-.4 1.7-.8 2.6-.1-.2-.2-.5-.3-.7 .1-.' +
    '3 .1-.6 .1-.8 8e-3 -0.4-0-.8 0-1.2" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1344.4,750.3)"><path d=' +
    '"m0 0c0.117 .2 .4 .8 .3 1.1s-.5 1.9-1.3 2.3c-.8 .4-1.4-.4-1.8-1.6l-.3 7e-3c-.1-.2-.1-.4-.2-.9-.1-.7-.3-1.1-1.3' +
    '-2.1-.9-.9-3.7-2.9-5.6-3.9-1.9-1-3.2-1.8-3.7-2.1-.5-.3-.3-.3 .1-.2 .5 .2 3 1 3.9 1.5 1 .4 2.2 1.2 3.6 2.2 1.6 ' +
    '1.1 2.6 2.3 2.9 3.3 .2 .7 .3 1 .3 1s0.604-.4 1.6-.6c1.021-.3 1.3-.2 1.4 0m-1.4 2.2c0.455-.2 .7-.7 .8-1-.5-0-1.' +
    '5 .3-1.9 .5 .2 .5 .7 .7 1.1 .6" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,1264.9,757.8)"><path d="m0 ' +
    '0c-1.4 .2-5 .8-5.9 3.1 .7 1.2 4.1 2.6 8.4 4 4.3 1.4 8.7 3.2 9.9 4 .3 .1 .8 .1 .8 .1 .2 .7 1.3 3 1.4 3.5-1.2-.1' +
    '-8.5-.7-11.8-.8-3.3-.2-9.5-.1-11.6-.1 1.3 1 4.3 2.9 8.7 4.6 .6 .2 1.1 .4 1.6 .6 .4-.7 .6-1.4 .7-2 .3 .3 .5 1.3' +
    ' .4 2.4 2.5 .9 3.8 1.2 4.4 1.3 .4 .5 1 2.5 1.1 4-.4 .7-1.6 1.7-2.6 2.5-1.5 1.1-3 2.1-4.6 1.6-2.1-.6-2.6-4.8-2.' +
    '1-5.7 .2-.3 .5-.8 1-1.4-1.6-.7-3.2-1.4-4.6-2.3-3.2-1.8-6.8-3.8-7.8-5.8l-0.3-.2c-.1-.2-.7-3.2-.8-3.5 .7 0 5.7 0' +
    ' 9.1 .1 3.5 .1 6.5 .2 7.7 .2-1.8-.5-6.4-2.3-7.7-3.4-1.3-1.1-2.2-2.8-2.2-5.6-1.2 .5-3.5 1.7-5.5 4.6-2.2 3.2-1.7' +
    ' 6.5-2.6 10.8-1.3 6.3-4 11.5-5.7 13.2-.6-2.2-.6-3.9-.6-3.9s2.116-5.1 3.2-8.3c1.071-3.2 2-6.4 1.9-7.1-.9-2.1-6.' +
    '1-6.5-10.5-9-4.1-2.4-7.8-2.7-9-1-.3 .3-.4 .7-.5 1.2 .6 .3 1.1 .6 1.7 .9 3.7 1.8 10.3 5.7 11.8 7.7 1.7 2.4 1.6 ' +
    '5.9 .7 7.9-1 2-2.5 4.3-2.6 5.1-.1 .4 1-.2 1.6-.2 .3 0 .2 .5-.5 1.2-.5 .6-2.6 2.4-3.4 3.1-.2 .2-.3 .1-.4-.1-.2-' +
    '.7-.5-2.3-.6-3.1l0.084-.4c0.226-.1 .5-.3 .6-.7 .2-.6 .8-2.2 1.8-4.2 1-2 2.5-4.3 2.6-5.4-1.2-1.7-7.3-5.2-13.2-8' +
    '.1 .4 1.2 .9 2.6 1.7 4.1 .2 .3 .4 .6 .6 .9 .6 1.2 .6 2.6 .3 2.3-.3-.3-.5-1.5-.9-1.6-.7-.2-1.7 .7-1.5 2.4 .2 1.' +
    '5 1 2.8 1.3 3.7 .4 1.2 .6 2.4 .2 1.7-.8-1.4-2.2-4.2-2.6-6.2-.4-1.9 0-3.3 .8-3.8 .3-.2 .6-.3 .8-.2-.5-1.1-1.2-2' +
    '.4-1.6-3.9-2.4-1.1-4.7-2.2-6.6-2.9-6.9-2.7-11.8-4.2-15.2-5.4l-.1-.1c0.252 .9 .2 1.6-.1 1.4-.3-.3-.5-1.5-.9-1.6' +
    '-.7-.2-1.7 .7-1.5 2.4 .2 1.5 1 2.8 1.3 3.7 .4 1.2 .6 2.4 .2 1.7-.8-1.4-2.2-4.2-2.6-6.2-.4-1.9 0-3.3 .8-3.8 .9-' +
    '.6 1.7 .1 2.4 1.4l0.216 .5c0.214 0 .6 .1 1.1 .2 1.6 .4 5.5 1 10.9 1.8 4 .6 6.8 1.7 9.4 3.1-0-.3-0-.6-2e-3 -1 .' +
    '1-4 2.5-5.1 5.8-4.3 3.2 .7 7.6 3.9 10.2 6 2.8 2.2 4.4 4.2 4.8 4.9 .7 1.7 .9 3.6 1 4.4 .2-2.4 .4-5.8 2.6-8.6 1.' +
    '9-2.6 5.9-6.3 13.5-6.4 0 1-.3 4-.3 4m-.5 24.5c1.076 1.3 3.4 .5 5.1-1.2-.9-.2-2.1-.6-3.4-1.1-.8 1-1.7 2-1.7 2.3' +
    '" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,952.6,471.1)"><path d="m0 0c0.488 .2 2 1 3.6 2 1.6 1 3.1 ' +
    '2.2 3.9 3 .3 .3 .5 .6 .7 .8 .5-.2 .8-.4 1-.5 .3-.1 .7-.3 1 .6 .3 1-.1 1.6-.6 2.3-.4 .6-1.2 1.5-1.7 1.8-.5 .2-.' +
    '7-1-.6-.9h0.325l0.063-0c-.7-.4-1.2-1.5-1.2-1.9-.1-.4 0-.8 1-1l0.386-.1c-.8-1-2.3-2.1-3.3-2.8-1.4-1.1-3.5-2.4-4' +
    '.1-2.8-.6-.4-.5-.5-.3-.4m8.672 7.5 .1 .5c0.675-.8 1.2-1.8 1.1-2-.3-0-.7 .3-1.4 .6 .1 .2 .1 .5 .2 .9m-1.9-1e-3c' +
    '-4e-3 .2 .3 .6 .8 .8 .5 .2 .8-.4 .8-1.2l-.2-.3-.5 .2c-.5 .2-.9 .3-1 .6" fill="#fff"/></g><g transform="matrix(' +
    '7.3,0,0,-6.8,1215.5,576.9)"><path d="m0 0c0.792 .6 3 2.3 4.2 3.4 .9 .8 1.9 1.9 2.6 2.9 .4-.3 .8-.6 1.2-0.8 .7-' +
    '.4 1-1.1 1-1.1 .1 .2 .7 1.4 .5 2-.1 .2-1 .7-1.9 1.3 .4 1.1 1.1 3 .2 3.6-.8 .6-2-.4-2.6-1.6-.5-1-.6-1.8 .4-2.5 ' +
    '.3-.2 .5-.4 .8-.6-.9-1.1-2.7-2.8-3.9-3.9-1.5-1.4-3-2.7-3.2-3.1l-.1-.1c-.3 1-.2 1.6-.5 1.3-1.1-1.8 .3-3.3 .8-4.' +
    '8-.7-.6-1.7-.1-2 .5-.7 1.2-.5 3.6-1.3 3.9-.2-.6-.4-1.4-.4-1.4s0.643-1.6 .5-2.7c-.1-.7-.6-1.4-1.3-1.4-1.9-.1-1 ' +
    '3-1.7 4.7-.1-.4-.3-.9-.4-1.2 .1-.4 .2-1.1 .2-1.4 0-.7-6e-3 -1.5 .1-2.1 .2-.9 .6-1.4 1.3-1.5 1.4-.1 2 1.1 2.2 2' +
    '.1 .2-1 2.1-2.2 3-.9 1.2 1.7 .2 3.1-.4 4.7l-.1 .2c0.086-0 .4 .1 .9 .5m5.472 9.4c0.464 .9 1.4 1 1.7 .5 .2-.4 .3' +
    '-1.1-.1-1.9-.9 .6-1.6 1.2-1.6 1.4" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,992.4,536.9)"><path d="m' +
    '0 0c-1.6 .1-2.5 1.8-3 4.1-.5 2.4-.2 5.5-.1 6.3 .1 .8-.6 .4-.9-1.5-0.3-1.9-.6-5 .5-8.3 1.1-3.2 2.9-4.4 4.5-4 1.' +
    '6 .4 3 4.4 3.5 6.2 .5 1.8 2.7 9.2 3.9 9.6 .2-.9-1-3.2-1.3-6.6-.4-3.4 .3-7.9 4.3-8.7 4-.8 6.7 2 7.7 4 1 1.9 1.4' +
    ' 4 1.6 5 .1-2.6 1.8-6.7 5-7.9 3.1-1.1 5.5-.1 6.5 1.4 .9 1.3 1.7 4 1.7 6 .1 2-1.6 5.8-1.9 7-.4 1.2-.6 2-.6 2.4-' +
    '0 .4 .8-.5 1.4-.7 .4-.1 .2 .8-.2 1.4-.4 .6-2.8 4.5-3 4.2-.1-.2-1.1-3.1-1.1-3.5 .4-.3 .8-1 .9-1.7 0-.7 .7-3.8 1' +
    '.3-5.6s1.728-5.1 1.8-6c-1.1-.9-3.7-2-6.2-.9-2.4 1.1-3.2 2.8-3.5 5.7-.2 1.9-.2 5.3-.8 8.2-.3 1.6-1.1 3.3-1.9 4.' +
    '1-.2-.5-1.1-3.8-1.1-3.8 0.3-.9 1.2-4.1 1.2-6.9-0-2.8-.2-5.5-3.1-7.3-2.9-1.9-7-1.1-8 1.8-1.1 2.9 1.3 9.5 1.3 11' +
    '.2-0 1.7-.3 2-1 1.7-.7-.3-2-1.9-3.2-4.7-1.2-2.7-1.7-5.4-2.4-7.7-.7-2.3-1.7-4.6-3.4-4.5" fill="#fff"/></g><g tr' +
    'ansform="matrix(7.3,0,0,-6.8,642.9,468.7)"><path d="m0 0c2.028 .2 3.7 1.8 4.2 2.3 .4 .4 .7 1.1 .4 .9-2.3-2.3-5' +
    '.5-2.3-5.7-1.9 .1 .4 .9 1 2.1 1.9 .7 .5 1.4 1 1.9 1.7l0.133-0c0.893-.2 1.9-.6 2.2-.3 .5 .5 .6 1.4 0 2.4-.5 .8-' +
    '1.6 1.6-2.5 2.1-.9 .5-1.1-.3-1.3-.6-.1-.3-.1-.5 .1-.5-.3-.5-.5-1-.6-1.5-.1-.3-0-.6 .1-.8 0-.1 .2-.3 .5-.4l0.41' +
    '3-.1c-.7-.7-1.5-1.3-2-1.5-.8-.5-1.7-1.4-2-2.3-.3-.9-.2-1.3 1.9-1.1m3.585 6.5 .1 .5v0.3c0.643-.5 1.7-1.5 1.6-2-' +
    '.4 0.1-1.2 .3-1.9 .5 .1 .2 .2 .5 .2 .8m-1.9-.1c-.5 .4-0 .8 .4 1.1 .5 .3 .9 .1 1.1-.8-.1-.3-.2-.5-.4-.7-.4 .1-1' +
    ' .4-1.1 .5" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,687.4,636)"><path d="m0 0c-.6-.5-.8-2.3-.7-2.4 ' +
    '.1-.1 1.9-.8 2.2-.9l0.13 .5c0.868-.8 1.8-5 2-5.1 .2-0 .5 .5 .7 1.6 .2 1 .4 2.6 .6 3.8 .2 1.2 .5 1.8 1.1 1.9 .6' +
    ' .1 1.1-.8 1.3-1.4 0 0 .5 1.2 .5 1.9-.1 .4-1.1 1.8-1.9 1.3-.8-.5-1.3-2.5-1.5-3.8-.2-1.3-.3-2.8-.5-3.1-.2 1.1-.' +
    '9 3-1.7 4.1-.9 1.2-2 1.7-2.3 1.4" fill="#fff"/></g><g transform="matrix(7.3,0,0,-6.8,630.6,621.4)"><path d="m0' +
    ' 0c0.761 .2 2.5 .5 3.3 1 .8 .4 2.1 2.3 2.6 3 .5 .7 .5 1.1 .4 1.3-.5 .3-3.9 .6-5.5 .2-.5-.3-1.3-2.1-1.5-2.5-.1-' +
    '.4 0-.3 .6-.2 .5 .1 3.1 .1 4.1-.2-.4-.3-3-1.7-3.6-2.1-.5-.3-.7-.5-.4-.5" fill="#fff"/></g><g transform="matrix' +
    '(7.3,0,0,-6.8,1778.1,690.4)"><path d="m0 0c-.1 2.1-1 5.4-4.7 10.5-1.3 1.7-3.1 4-4.9 6.3-.1 .8-.1 1.5-.2 2.1-.2' +
    ' 3.2-1.1 9.7-1.4 13.5-.1 1-.1 2-.1 2.5 0 .4 .3 .4 .7-.1 .4-.4 1-1.1 1.1-1 .3 0.1 0 1.1-0.5 2.2-.5 1.2-2.6 5.8-' +
    '2.9 6-.2 .1-1.1-2.6-1.2-3.2 .2-.3 .7-.9 .7-2.4 .1-1.6 .9-10.7 1.4-16.5l0.027-.3c-2.8 3.4-5.5 6.5-6.6 7.8-.2 .2' +
    '-.4 .5-.6 .7-.2 1.5-.3 3-.5 4.2-.1 1-.1 2-.1 2.5 9e-3 .4 .3 .4 .7-.1 .4-.4 1-1.1 1.1-1 .3 .1 0 1.1-.5 2.2-.5 1' +
    '.2-2.6 5.9-3 6.1-.2 .1-1.2-2.9-1.2-3.4 .2-.3 .7-.9 .7-2.4 0-.7 .2-2.7 .4-5.2-1.9 2.4-3.7 4.9-3.8 5.4-0 .3 .3 .' +
    '1 1.1-0 .7-.1 1.4-.4 1.3 0-.1 .2-.3 .6-1 1.1-.7 .5-2.5 1.7-3.8 2.5-1.3 .9-2 1.6-2.3 1.4-.1-.1-0-3 .1-3.4 .3-0 ' +
    '1-.3 1.3-.9 .4-.6 2.9-4.4 5-7 .6-.8 1.5-1.9 2.6-3.3 .2-2.4 .4-4.9 .6-7 .4-4.7 1.9-17.2 1.9-21.3-1.1-1.1-3.3-2.' +
    '6-5.6-2.7-2.3-0-3.5 .6-4.5 2.5-.3 .6-.5 1.1-.8 1.7-.6 1.2-2 1.9-3.3 1.6l-.2-.1-.4-.2c-.9-.5-1.8-1.4-2.8-2.7-1.' +
    '6-2.3-2.6-4.8-3.8-7-1.2-2.3-2.2-3.8-4.3-3.4-1.5 .3-2.7 1.7-3.4 3.4 2 1.5 3.4 3.4 4.5 6.1 1.4 3.5 1.9 7.4 1.7 1' +
    '1.8-.1 4.2-1.9 13.9-2.3 17.7-.5 3.8-1.1 6.8-1 7.6 .1 .8 1.2-1 1.8-1.2 .3 .1 .1 1.2-.4 2.2-.4 .7-1.6 3.7-2.4 5.' +
    '2-.4 .7-.5 1.1-.6 1.2-.2 .1-1.5-3-1.3-3.3 .4-.6 .7-.9 .7-2 .1-1.1 1-9.1 1.8-14.9 .6-4.4 1.9-12.5 2.1-18.4 .1-1' +
    '.9-0.2-3.3-.4-4.1-.6-1.2-1.5-2.5-4.8-5-.5 3.6 0 6.4-.4 6.7-.5-.1-.6-1.7-.7-3.8-0-.9 8e-3 -2.2 .2-3.7-4-2.9-9.3' +
    '-5.5-11.8-6.9-1.5-.8-.9-1 .3-.6 1.2 .4 8 2.3 11.6 4.4l0.39 .2c0.184-.7 .4-1.4 .7-2 1.2-2.7 3-4.4 4.8-4.2 1.6 .' +
    '1 2.7 2 3.7 4.2 1 2.2 2.7 6.4 4.4 8 .6 .6 1.3 1.1 2 1.4 0 0 1.1 .4 2.2-.3 .4-.3 .7-.7 .8-1.1 .4-1 .9-2.2 1.9-3' +
    '.3 1.8-1.9 4.6-1.5 6.8-.4 2.1 1.1 3.2 2.8 3.7 4.8 .8 3.4 .7 6.9 .5 10-.2 3.5-.7 7.2-1 11-.1 1.2-.3 3-.5 4.8 2.' +
    '1-2.6 4.3-5.2 5.6-6.7 .5-.5 .9-1.1 1.4-1.6 .4-5.8 .8-13.1 1-16.1 .2-3 .1-6.9 0-7.5-0-.7 .3-.6 .8 .9 .7 2 1.1 7' +
    '.2 .9 10.6-.1 2-.3 5.8-.5 9.3 1.6-2.1 3.2-4.2 4.2-5.6 1.8-2.5 3.4-5.5 4-7.4 .6-1.9 .6-2.4 .7-2.8s0.602 1 .5 3.' +
    '2" fill="#fff"/></g></g><path d="m1558.8 1170.7c-1.2-3.4-4.8-5.8-9.1-5.8s-7.9 2.5-9.1 5.8h-40.7c-.4-4.5-0-9 1.' +
    '3-13.5l83.981-.1 2.3 3.9c2.1113 3.6 4.8 6.8 7.9 9.6zm55.596-39h-100.9c7.7559-5.6 11.8-13.8 10.7-22-.7-5.2-5.9-' +
    '9.1-12.1-9.6h-3.2c-7.7 .7-13.2 6.3-12.4 12.3l0.3079 2.3 .4 3.6c0.4106 4.5 0 9-1.3 13.4h-746c11.077 16.1 31.3 2' +
    '6 53.1 26l680.71-.4c-7.8 5.6-11.9 13.8-10.8 22.1 .8 6.1 7.7 10.4 15.3 9.6 7.6-.7 13.2-6.3 12.4-12.3l-.3-2.3h40' +
    '.004c0.7037 3.9 4.6 6.9 9.4 6.9s8.6502-3 9.4-6.9h40.693v-.1c8.4963 6 19.3 9.5 30.7 9.5 10.7 0 19.5-7.5 19.5-16' +
    '.7v-4.8c0-16.8-15.9-30.5-35.6-30.5" fill="#fff"/></g></svg>';
  FLAG_SVG.KW =
    '<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="600" viewBox="0 0 12 6"><rect width="12" height="' +
    '6" fill="#007a3d"/><rect width="12" height="4" y="2" fill="#fff"/><rect width="12" height="2" y="4" fill="#ce1' +
    '126"/><polygon points="0,0 3,2 3,4 0,6"/></svg>';
  FLAG_SVG.OM =
    '<svg width="1050" height="600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1050 600"><path fill="#028002" ' +
    'd="M0 0h1050v600H0z"/><path fill="#db171b" d="M0 0h1050v400H0z"/><path fill="#fff" d="M0 0h1050v200H0z"/><path' +
    ' fill="#db171b" d="M0 0h350v600H0z"/><path fill="#fff" stroke="#fff" stroke-width=".2" d="M240 21L236 23L228 3' +
    '6L200 71L185 93L184 73L178 65L176 59L178 45L181 42L183 43L184 41L177 32L174 32L173 30L167 33L161 42L162 44L163' +
    ' 43L167 45L169 51L168 66L161 74L161 100L143 70L114 35L109 25L103 23L103 29L110 38L131 79L148 107L144 104L137 1' +
    '08L136 101L108 102L107 122L136 122L138 115L144 118L148 116L153 116L155 119L159 120L161 127L133 131L130 130L129' +
    ' 132L129 130L126 131L124 135L125 139L143 148L114 176L80 202L78 205L79 208L83 209L88 208L102 201L136 174L158 15' +
    '1L170 149L178 144L204 170L236 196L255 207L261 207L265 206L264 201L246 189L223 169L185 131L186 118L188 116L194 ' +
    '118L201 115L202 122L231 121L230 101L202 101L201 108L196 104L210 82L233 40L242 28L242 23ZM240 22L240 25L238 24Z' +
    'M104 23L106 25L104 26ZM238 25L240 27L234 34L232 33ZM107 25L108 27L106 29L107 29L109 28L112 34L110 35L104 28ZM2' +
    '37 26L236 27L238 28L239 27ZM172 33L177 34L168 34ZM176 34L177 35L176 43L174 36L171 35L169 37L170 42L169 45L171 ' +
    '46L169 49L167 35ZM172 35L175 36L176 39L172 43L170 42L169 39L170 36ZM172 36L169 39L172 42L175 39ZM172 36L175 38' +
    'L173 42L169 39ZM172 36L170 38L172 41L175 39ZM172 37L174 39L172 41L170 39ZM172 37L171 39L172 40L173 39ZM229 40L' +
    '229 41L227 42L227 40ZM230 40L231 41L229 41ZM115 41L115 42L113 42ZM118 41L120 44L118 43ZM229 42L229 44L227 45L2' +
    '27 42ZM174 42L175 45L172 45L174 48L171 48L171 45L170 45L169 44L170 43L171 45L172 43L173 44ZM226 43L226 45L224 ' +
    '46L224 43ZM115 43L117 44L117 46L115 46ZM223 44L223 46L221 46ZM117 44L119 45L119 47L117 47ZM176 45L176 48L175 4' +
    '8L174 46ZM120 45L123 48L120 47ZM226 46L226 49L224 50L224 46ZM223 47L223 50L221 51L221 48ZM118 47L119 48L119 51' +
    'L117 50ZM120 48L123 49L123 52L120 51ZM220 48L220 51L217 52ZM174 49L176 49L169 50ZM124 49L127 53L124 52ZM223 51' +
    'L223 54L221 55L220 52ZM220 52L220 56L216 57L216 53ZM120 52L123 53L123 57L120 56ZM173 53L172 54L176 53L176 56L1' +
    '69 56L171 55L169 55L169 53ZM124 53L127 54L127 58L124 57ZM216 53L216 57L212 58ZM128 55L132 60L128 58ZM220 56L21' +
    '9 62L217 62L216 58ZM173 57L176 58L169 58ZM216 58L216 62L212 64L212 59ZM123 58L127 59L127 64L124 62ZM128 59L132' +
    ' 61L132 65L128 64ZM211 59L211 64L206 65ZM172 60L176 61L169 61ZM133 61L137 67L132 65ZM172 61L176 62L169 62ZM172' +
    ' 62L174 62L173 65L176 65L176 68L174 68L176 67L175 65L174 68L169 67L169 65L172 65ZM176 62L176 65L174 64ZM170 62' +
    'L171 64L169 65ZM219 62L217 66L216 63ZM216 63L216 68L212 70L212 65ZM125 64L127 64L126 67ZM128 65L131 66L131 71L' +
    '127 69ZM211 65L211 70L207 72L206 66ZM177 66L181 72L178 73L176 69ZM132 66L137 68L136 73L132 71ZM206 67L206 71L2' +
    '03 69ZM168 67L170 69L168 74L166 72L164 72ZM172 68L175 69L177 72L176 76L174 78L170 77L168 74L169 70ZM137 68L141' +
    ' 70L137 73ZM173 69L170 70L169 73L170 76L173 77L175 76L177 73L176 70ZM173 69L175 70L177 73L176 76L173 77L170 76' +
    'L169 73L170 70ZM173 69L171 70L169 73L172 76L176 73ZM215 69L213 74L212 70ZM173 70L176 73L172 76L170 73ZM172 70L' +
    '170 73L173 75L175 72ZM173 71L175 73L173 75L171 73ZM212 71L212 75L208 72ZM128 71L131 72L130 75ZM173 71L171 73L1' +
    '73 75L174 73ZM203 72L205 73L202 75ZM182 72L184 73L183 78L162 79L163 73L164 76L166 77L168 74L173 78L178 74L180 ' +
    '76L182 76ZM131 72L135 74L131 77ZM202 72L201 76L199 74ZM143 72L144 75L142 73ZM141 73L141 77L138 75ZM142 74L144 ' +
    '76L142 78ZM206 74L209 76L206 78ZM206 74L205 78L202 76ZM137 76L137 80L134 78ZM138 76L141 78L138 80ZM209 77L209 ' +
    '81L206 79ZM196 78L207 85L198 98L187 92ZM134 79L137 81L134 82ZM196 79L188 92L197 97L205 85ZM183 80L183 82L182 8' +
    '1L177 82L175 81ZM196 80L205 85L197 97L193 94L196 96L194 93L189 91L191 88L192 88L189 91L191 90L196 94L200 88L20' +
    '1 85L196 83L194 84ZM147 80L156 93L145 100L136 87ZM163 80L169 81L168 83L172 83L172 81L173 80L173 82L174 81L180 ' +
    '82L180 81L184 82L164 83L162 83L166 82L167 83L167 82L163 82ZM147 81L138 87L145 99L155 93ZM197 82L197 83L200 83Z' +
    'M147 82L154 93L148 95L146 98L150 96L146 99L138 87ZM196 83L201 86L196 93L192 90ZM147 84L141 88L146 96L152 92ZM1' +
    '97 85L193 90L196 92L200 87ZM147 85L151 92L146 95L142 88ZM142 85L139 87L143 87ZM197 85L199 87L196 91L194 90ZM14' +
    '6 87L143 88L147 94L150 92ZM146 87L149 92L147 93L144 89ZM183 90L184 90L183 91ZM181 90L179 92L184 92L179 93L162 ' +
    '92L162 90L165 90L163 91L163 92L166 91L167 92L167 90ZM176 91L173 92L178 92ZM171 91L168 92L173 92ZM186 93L197 10' +
    '0L194 104L196 100L186 94L185 95ZM157 95L161 102L156 96L147 102L149 107L146 102ZM184 96L177 97L162 97ZM187 97L1' +
    '87 99L186 99ZM184 97L185 102L162 102L162 98ZM189 99L190 100L188 101ZM192 100L192 102L191 103ZM153 101L155 101L' +
    '154 103L153 103ZM152 101L152 102L151 102ZM190 101L190 102L188 102ZM230 105L202 105L202 103L230 102ZM128 102L13' +
    '6 102L135 105L108 105L108 102ZM184 103L184 107L162 106L162 103ZM195 105L199 108L196 105L191 107ZM195 105L198 1' +
    '08L196 106L193 107ZM142 105L145 107L142 106L140 108ZM216 105L230 106L230 116L202 117L202 115L204 114L205 112L2' +
    '04 108L202 108L202 106ZM133 106L136 106L136 108L133 108L134 114L136 115L136 117L108 117L108 106ZM189 106L184 1' +
    '10L177 113ZM195 106L197 108L195 115ZM142 106L144 107L143 108L143 115L142 114L141 108ZM153 106L161 111L157 110Z' +
    'M152 107L157 110L163 112L157 111ZM181 107L183 107L178 108L176 112L176 117L182 118L178 118L175 116L177 118L181 ' +
    '119L178 119L175 117L174 112L177 108ZM212 107L212 110L208 111L210 113L213 112L212 115L218 113L220 115L221 113L2' +
    '19 112L222 113L224 111L220 110L220 107L218 109ZM159 107L163 109L166 112L166 116L164 119L165 112L162 109L158 10' +
    '8ZM118 107L118 110L114 111L116 113L118 112L118 115L123 114L125 115L127 114L125 112L128 113L129 111L126 110L126' +
    ' 107L124 109ZM220 107L219 110L223 111L222 112L219 112L220 115L214 113L212 115L213 112L210 113L209 111L213 110L' +
    '212 107L218 109ZM125 108L125 110L129 111L127 113L125 112L126 115L120 113L118 115L119 112L116 113L114 111L119 1' +
    '10L117 108L123 109ZM164 108L176 108L170 110ZM194 110L194 113L188 112L188 111ZM152 110L154 111L153 113L143 112L' +
    '143 110ZM156 112L164 114L157 113L154 112ZM185 113L186 115L184 114ZM167 113L174 114L168 115ZM180 114L187 116L17' +
    '7 115ZM180 115L187 117L177 115ZM197 115L195 117L191 116ZM202 118L230 117L230 121L202 121ZM134 117L136 117L136 ' +
    '121L108 121L108 118ZM184 118L184 122L169 130L161 127L162 121L165 119L181 120ZM185 123L184 131L180 140L176 145L' +
    '170 148L169 131ZM161 128L168 130L156 134L156 129ZM155 129L154 134L153 130ZM152 130L155 136L154 150L145 147L146' +
    ' 131ZM144 131L144 147L134 143L132 141L134 131ZM168 131L169 148L155 150L156 135ZM184 132L213 162L245 189L214 16' +
    '4ZM184 133L212 162L244 189L234 192L202 165L179 142ZM129 135L129 138L130 136L130 140ZM183 139L187 142L185 144L1' +
    '89 145L189 143L188 144ZM179 143L205 169L234 192L204 169ZM190 146L189 150L188 149L188 150L198 152L196 149L195 1' +
    '49L196 150L195 151L191 149ZM144 148L122 170L98 190ZM145 149L152 150L149 152L148 150L146 153L147 152L151 152L15' +
    '2 150L156 151L135 172L109 193L99 190ZM157 151L137 171L110 193L137 170ZM199 154L198 157L203 163L204 158L202 158' +
    'L203 160L200 159L198 157ZM144 154L143 155L145 155L145 157L143 160L141 161L141 158L139 159L140 163L146 158L146 ' +
    '155ZM206 158L206 160L207 160L205 163L207 161L209 163L211 167L209 168L212 170L211 165ZM137 159L132 164L131 170L' +
    '134 169L132 166L134 163L137 161L139 163ZM215 169L212 171L213 173L213 171L216 170L220 173L218 176L223 174L222 1' +
    '72L222 174ZM128 169L121 175L125 176L126 174L124 175L124 174L128 170L130 171L131 173L131 170ZM222 175L220 180L2' +
    '31 181L228 178L228 180L224 179ZM121 176L120 180L117 180L116 178L113 181L124 180ZM112 183L110 184L112 184L111 1' +
    '88L108 189L107 186L106 187L107 192L112 187ZM232 183L231 184L231 186L237 190L238 186L236 186L236 188L234 187L23' +
    '2 185L232 184L233 184ZM246 190L263 201L264 205L254 205L234 194L235 192ZM97 191L105 192L109 195L90 206L83 208L7' +
    '9 207L81 202ZM248 192L238 194L255 204L260 206L263 204L263 202ZM248 192L261 201L263 204L260 205L255 204L239 195' +
    'ZM94 193L81 203L80 206L83 207L90 205L106 195ZM249 193L241 195L256 204L262 204L261 202ZM95 193L104 195L89 205L8' +
    '4 207L80 206L81 204ZM249 194L261 204L257 203L249 200L250 198L249 199L244 196L245 196L244 195ZM95 194L83 203L81' +
    ' 206L88 205L103 196ZM248 195L246 196L246 197L248 197L248 196L248 197L246 197L248 195L252 200L253 200L253 197L2' +
    '52 197L253 198L252 200L251 196L250 197ZM95 195L94 197L96 197L96 196L97 197L93 198L92 197L90 199L90 201L93 200L' +
    '91 200L90 201L90 199L97 198L96 195L99 195L98 197L101 196L87 204L82 205L83 203L85 205L88 201L89 202L89 201L86 2' +
    '01ZM243 195L243 196L242 195ZM255 199L253 201L260 203L259 201L255 201ZM85 202L86 203L84 204Z"/></svg>';
  FLAG_SVG.AE =
    '<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="600" viewBox="0 0 12 6"><rect width="12" height="' +
    '6" fill="#00843d"/><rect width="12" height="4" y="2" fill="#fff"/><rect width="12" height="2" y="4"/><rect wid' +
    'th="3" height="6" fill="#c8102e"/></svg>';
  FLAG_SVG.BH =
    '<svg xmlns="http://www.w3.org/2000/svg" width="1000" height="600" viewBox="0 0 100 60"><path fill="#fff" d="m0' +
    ' 0h100v60H0z"/><path fill="#da291c" d="m25 0h75v60H25l15-6-15-6 15-6-15-6 15-6-15-6 15-6-15-6 15-6z"/></svg>';
  FLAG_SVG.QA =
    '<svg xmlns="http://www.w3.org/2000/svg" width="1400" height="550" viewBox="0 0 75 18" preserveAspectRatio="non' +
    'e"><path d="M0,0H75V18H0" fill="#8a1538"/><path d="M22,18H0V0H22l6,1-6,1 6,1-6,1 6,1-6,1 6,1-6,1 6,1-6,1 6,1-6' +
    ',1 6,1-6,1 6,1-6,1 6,1z" fill="#fff"/></svg>';
  FLAG_SVG.JO =
    '<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="600" viewBox="0 0 10080 5040"><path fill="#fff" d' +
    '="m0 0h10080v5040H0z"/><path d="m0 0h10080v1680H0z"/><path fill="#007a3d" d="m0 3360h10080v1680H0z"/><path fil' +
    'l="#ce1126" d="m5040 2520L0 5040V0m1557 2160-78 198-203-62 106 184-176 120 211 32-16 212 156-144 157 144-16-21' +
    '2 210-32-175-120 106-184-203 62z"/></svg>';
  FLAG_SVG.IQ =
    '<svg xmlns="http://www.w3.org/2000/svg" width="900" height="600" viewBox="0 0 11880 7920"><path fill="#fff" d=' +
    '"m0 0h11880v7920H0z"/><path fill="#cd1125" d="m0 0h11880v2640H0z"/><path d="m0 5280h11880v2640H0z"/><path fill' +
    '="#017b3d" d="m5864 4515H3929a288 248 0 0 1-365 215c271-133 254-268 83-568 95-34 110-43 206-108-68 206 176 181' +
    ' 356 181 0-72 7-154-47-165 70-25 76-33 187-127v277h1335v-190a40 40 0 0 0-80 0v110a30 30 0 0 1-30 30H4554v-180l' +
    '766-740c-5 38 74 140 107 157-25 4-53-1-71 17l-627 606h695c0-161 150-161 220-218 70 57 220 57 220 218zm145 0V32' +
    '50c71 39 126 84 214 106-4 50-49 66-49 101v778c98 22 120-35 167-64 12 124 91 246 88 344zm1322-845 155-130v680h1' +
    '10v-773c54-45 124-94 155-151v1219h-975c-14-252-14-511 280-455v-103c0-24-36-5-36-27l201-168v458h110zm-51-348c-1' +
    '9 1-48-103-41-123 7-23 33-23 44-12 18 17 16 134-3 135zm-181 141c-55-32-46-45 2-31 83 25 125 4 185-57l45 23c59 ' +
    '30 95 17 116-55 6-22 24-16 29 9 19 100-57 131-134 103-42-14-49-14-70 2-46 36-112 42-173 6zm797 1052V3250c71 39' +
    ' 126 84 214 106-4 50-49 66-49 101v778c98 22 120-35 167-64 12 124 91 246 88 344zm-3791 140a1 1 0 0 1 118 0 1 1 ' +
    '0 0 1-118 0zm2861-460a45 34 0 0 0 90 0 45 34 0 0 0-90 0z"/></svg>';

  // Heart colors come from each flag. Near-white is skipped (invisible on white pages).
  // Each entry is [base color, weight]; every base is used in several tints.
  var EVENTS = [
    { code: 'SA', name: 'Saudi National Day',      colors: [['#006C35', 1]] },
    { code: 'KW', name: 'Kuwait National Day',     colors: [['#007A3D', 3], ['#CE1126', 3], ['#1b1b1b', 1]] },
    { code: 'OM', name: 'Oman National Day',       colors: [['#DB171B', 3], ['#028002', 3]] },
    { code: 'AE', name: 'UAE National Day',        colors: [['#00843D', 3], ['#C8102E', 3], ['#1b1b1b', 1]] },
    { code: 'BH', name: 'Bahrain National Day',    colors: [['#DA291C', 1]] },
    { code: 'QA', name: 'Qatar National Day',      colors: [['#8A1538', 1]] },
    { code: 'JO', name: 'Jordan Independence Day', colors: [['#007A3D', 3], ['#CE1126', 3], ['#1b1b1b', 1]] },
    { code: 'IQ', name: 'Iraq National Day',       colors: [['#CD1125', 3], ['#017B3D', 3], ['#1b1b1b', 1]] }
  ];

  // ---------- colors ----------

  function mix(hex, t) {          // blend a #rrggbb color toward white by t (0..1)
    var n = parseInt(hex.slice(1), 16), out = '#';
    for (var s = 16; s >= 0; s -= 8) {
      var c = (n >> s) & 255;
      c = Math.round(c + (255 - c) * t);
      out += (c < 16 ? '0' : '') + c.toString(16);
    }
    return out;
  }

  function luminance(hex) {
    var n = parseInt(hex.slice(1), 16);
    return (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255;
  }

  EVENTS.forEach(function (ev) {
    ev.svg = FLAG_SVG[ev.code];
    ev.palettes = [];
    ev.bag = [];
    ev.colors.forEach(function (c, i) {
      var steps = luminance(c[0]) < 0.12 ? [0, 0.2, 0.4] : [0, 0.15, 0.3, 0.45, 0.6, 0.75, 0.88];
      ev.palettes.push(steps.map(function (t) { return mix(c[0], t); }));
      for (var w = 0; w < c[1]; w++) ev.bag.push(i);
    });
  });

  function pick(arr) { return arr[(Math.random() * arr.length) | 0]; }
  function heartColor(ev) { return pick(ev.palettes[pick(ev.bag)]); }

  // ---------- which celebration does this visitor get? ----------

  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; }
  }

  function eventByCode(code) {
    for (var i = 0; i < EVENTS.length; i++) if (EVENTS[i].code === code) return EVENTS[i];
    return null;
  }

  // The visitor's local calendar day (or the ?party_date=YYYY-MM-DD test date), at midnight.
  function today() {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(param(CONFIG.dateParam) || '');
    var d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  // Is `day` within [daysBefore before, daysAfter after] of any of this country's dates?
  // Neighbouring years are checked too, so windows that cross New Year still work.
  function inWindow(code, day) {
    var list = CONFIG.dates[code] || [];
    for (var i = 0; i < list.length; i++) {
      for (var y = day.getFullYear() - 1; y <= day.getFullYear() + 1; y++) {
        var start = new Date(y, list[i][0] - 1, list[i][1] - CONFIG.daysBefore);
        var end = new Date(y, list[i][0] - 1, list[i][1] + CONFIG.daysAfter);
        if (day >= start && day <= end) return true;
      }
    }
    return false;
  }

  // Events running on the given day, restricted to the countries switched on.
  function activeEvents(day) {
    return EVENTS.filter(function (ev) {
      return CONFIG.countries.indexOf(ev.code) > -1 && inWindow(ev.code, day);
    });
  }

  // The country only matters when the answer can differ by visitor.
  function needsCountry(active) {
    return active.length > 1 || CONFIG.audience === 'local';
  }

  // Pure choice rule. `cycle` is a rotating counter used for visitors from other countries.
  function choose(active, country, cycle) {
    if (!active.length) return null;
    for (var i = 0; i < active.length; i++) if (active[i].code === country) return active[i];
    if (CONFIG.audience === 'local') return null;
    return active[cycle % active.length];
  }

  // Rotates through the events: every new tab or new visit gets the next one.
  function nextCycle() {
    try {
      var n = parseInt(localStorage.getItem('ph_cycle'), 10) || 0;
      localStorage.setItem('ph_cycle', String(n + 1));
      return n;
    } catch (e) { return Math.floor(Math.random() * 1000); }
  }

  function fetchText(url, ms) {
    return new Promise(function (resolve, reject) {
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; reject(new Error('timeout')); } }, ms);
      fetch(url, { credentials: 'omit', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (t) { if (!done) { done = true; clearTimeout(timer); resolve(t); } })
        .catch(function (e) { if (!done) { done = true; clearTimeout(timer); reject(e); } });
    });
  }

  function validCode(c) { return typeof c === 'string' && /^[A-Z]{2}$/.test(c) ? c : null; }

  // Tries, in order: Cloudflare trace on your own domain (no third party),
  // then two free country lookup endpoints. Result is cached for 24 hours.
  function detectCountry() {
    try {
      var cached = JSON.parse(localStorage.getItem('ph_country') || 'null');
      if (cached && validCode(cached.c) && Date.now() - cached.t < 86400000) {
        return Promise.resolve(cached.c);
      }
    } catch (e) {}

    function remember(c) {
      try { localStorage.setItem('ph_country', JSON.stringify({ c: c, t: Date.now() })); } catch (e) {}
      return c;
    }

    var attempts = [
      function () {
        return fetchText('/cdn-cgi/trace', 2500).then(function (t) {
          var m = /^loc=([A-Z0-9]{2})$/m.exec(t);
          return m ? validCode(m[1]) : null;
        });
      },
      function () {
        return fetchText('https://api.country.is/', 3500).then(function (t) {
          return validCode(String(JSON.parse(t).country || '').toUpperCase());
        });
      },
      function () {
        return fetchText('https://ipapi.co/country/', 3500).then(function (t) {
          return validCode(t.trim().toUpperCase());
        });
      }
    ];

    return attempts.reduce(function (chain, attempt) {
      return chain.then(function (found) {
        if (found) return found;
        return attempt().then(function (c) { return c; }, function () { return null; });
      });
    }, Promise.resolve(null)).then(function (c) { return c ? remember(c) : null; });
  }

  // Resolves to the event to play, or null for "play nothing".
  function resolveEvent() {
    var force = param(CONFIG.forceParam);
    if (force === '0') return Promise.resolve(null);
    if (force) {
      var forced = eventByCode(force.toUpperCase());
      if (forced) return Promise.resolve(forced);
      if (force === '1') return Promise.resolve(activeEvents(today())[0] || EVENTS[0]);
    }

    if (!CONFIG.enabled) return Promise.resolve(null);
    if (CONFIG.respectReducedMotion && window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return Promise.resolve(null);
    if (CONFIG.showOncePerSession) {
      try { if (sessionStorage.getItem('ph_shown')) return Promise.resolve(null); } catch (e) {}
    }

    var active = activeEvents(today());
    if (!active.length) return Promise.resolve(null);

    if (!needsCountry(active)) return Promise.resolve(active[0]);

    // If the country can't be determined, the visitor is treated as "rest of the world".
    return detectCountry().then(function (country) {
      var own = choose(active, country, 0);
      var ownMatch = own && own.code === country;
      if (ownMatch || CONFIG.audience === 'local') return own;
      return choose(active, country, nextCycle());
    });
  }

  // ---------- animation ----------

  function rand(a, b) { return a + Math.random() * (b - a); }

  function heartPath(ctx, s) {
    ctx.beginPath();
    ctx.moveTo(0, s * 0.9);
    ctx.bezierCurveTo(-s * 1.4, s * 0.1, -s * 0.75, -s * 0.95, 0, -s * 0.3);
    ctx.bezierCurveTo(s * 0.75, -s * 0.95, s * 1.4, s * 0.1, 0, s * 0.9);
    ctx.closePath();
  }

  function start(ev) {
    try { if (CONFIG.showOncePerSession) sessionStorage.setItem('ph_shown', '1'); } catch (e) {}

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:' + CONFIG.zIndex;
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');

    var flagImg = null, flagAspect = 2 / 3;
    if (CONFIG.flagRatio > 0) {
      var img = new Image();
      img.onload = function () {
        if (img.naturalWidth) flagAspect = img.naturalHeight / img.naturalWidth;
        flagImg = img;
      };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(ev.svg);
    }

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0;
    function resize() {
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);

    var particles = [];

    function spawn(initialOffset) {
      var isFlag = flagImg && Math.random() < CONFIG.flagRatio;
      var size = isFlag ? rand(44, 62) : rand(9, 26);   // flags: width in px, hearts: radius
      var life = isFlag ? rand(4.5, 6.5) : rand(4, 7.5);
      particles.push({
        flag: isFlag,
        x: rand(0, W),
        y: initialOffset ? initialOffset : -size * 2,
        vy: isFlag ? rand(55, 90) : rand(70, 150),
        swayAmp: rand(12, 40),
        swayFreq: rand(0.6, 1.6),
        phase: rand(0, Math.PI * 2),
        rot: rand(-0.4, 0.4),
        rotSpeed: isFlag ? rand(-0.08, 0.08) : rand(-0.5, 0.5),
        size: size,
        color: heartColor(ev),
        life: life,
        age: 0
      });
    }

    var t0 = performance.now(), last = t0, carry = 0;
    var perSecond = function () { return Math.min(45, (W / 900) * 26) * CONFIG.density; };

    // opening burst so the effect is felt immediately
    var burst = Math.round(26 * CONFIG.density);
    for (var i = 0; i < burst; i++) spawn(rand(0, H * 0.45));

    function alphaFor(p) {
      var f = p.age / p.life;
      if (f < 0.12) return f / 0.12;         // fade in
      if (f > 0.55) return Math.max(0, 1 - (f - 0.55) / 0.45); // fade out
      return 1;
    }

    function frame(now) {
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;
      var spawning = now - t0 < CONFIG.durationMs;

      if (spawning) {
        carry += perSecond() * dt;
        while (carry >= 1) { spawn(0); carry -= 1; }
      }

      ctx.clearRect(0, 0, W, H);

      for (var i = particles.length - 1; i >= 0; i--) {
        var p = particles[i];
        p.age += dt;
        if (p.age >= p.life || p.y > H + 60) { particles.splice(i, 1); continue; }

        p.y += p.vy * dt;
        p.phase += p.swayFreq * dt;
        p.rot += p.rotSpeed * dt;
        var x = p.x + Math.sin(p.phase) * p.swayAmp;

        ctx.save();
        ctx.globalAlpha = alphaFor(p) * (p.flag ? 0.95 : 0.85);
        ctx.translate(x, p.y);
        if (p.flag) {
          // keep flags nearly upright so any script stays readable and is never flipped
          ctx.rotate(Math.max(-0.2, Math.min(0.2, p.rot)));
          var fw = p.size, fh = fw * flagAspect;
          ctx.drawImage(flagImg, -fw / 2, -fh / 2, fw, fh);
        } else {
          ctx.rotate(p.rot * 0.6);
          heartPath(ctx, p.size);
          ctx.fillStyle = p.color;
          ctx.fill();
          // soft highlight
          ctx.globalAlpha *= 0.35;
          ctx.beginPath();
          ctx.ellipse(-p.size * 0.42, -p.size * 0.35, p.size * 0.22, p.size * 0.12, -0.6, 0, Math.PI * 2);
          ctx.fillStyle = '#ffffff';
          ctx.fill();
        }
        ctx.restore();
      }

      if (spawning || particles.length) {
        requestAnimationFrame(frame);
      } else {
        window.removeEventListener('resize', resize);
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    }

    requestAnimationFrame(frame);
  }

  function boot() {
    resolveEvent().then(function (ev) { if (ev) start(ev); }, function () {});
  }

  // Manual trigger, e.g. from a button: PartyHearts.start() or PartyHearts.start('QA')
  window.PartyHearts = {
    start: function (code) {
      start((code && eventByCode(String(code).toUpperCase())) || activeEvents(today())[0] || EVENTS[0]);
    },
    events: EVENTS,
    activeEvents: activeEvents,
    choose: choose
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
